import React from 'react';
import msme from '../../utils/msme1.png';
import iso from '../../utils/iso.png';
import ind from '../../utils/startup-ind.png';



export default function     TrustBadges() {
  const badges = [
    {
      label: 'Ministry of MSME',
      sub: 'Govt of India Registered Company',
      icon: msme,
      round: false,
    },
    {
      label: 'ISO 9001-2015',
      sub: 'Certified Company',
      icon:iso,
      round: true,
    },
    {
      label: 'Startup India',
      sub: 'DPIIT Recognised Startup',
      icon: ind,
      round: false,
    },
  ];

  return (
    <div className="border-t border-b border-border/30 py-4 px-6">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-between gap-4">
        {badges.map((badge, i) => (
          <React.Fragment key={badge.label}>
            <div className="flex items-center gap-3 flex-1 min-w-[180px]">
              {/* Icon wrapper */}
              <div className={`w-13 h-13 flex items-center justify-center border border-border/30 bg-background flex-shrink-0 p-1.5
                ${badge.round ? 'rounded-full' : 'rounded-lg'}`}
                style={{ width: 56, height: 56 }}
              >
                <img src={badge.icon} alt="" />
              </div>
              <div>
                <p className="text-sm font-medium text-white leading-tight">{badge.label}</p>
                <p className="text-[11px] text-white mt-0.5">{badge.sub}</p>
              </div>
            </div>
            {/* Divider — hide after last item */}
            {i < badges.length - 1 && (
              <div className="hidden sm:block w-px h-10 bg-border/40 flex-shrink-0" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}